import React from 'react'

import Form, { formTypes } from './../../Forms/Containers/FormCreator'

function ChangePassAdmin(props) {
  const defaultProperties = {
    classLabel: "input-text",
    classContainer: "line line-60 input-text-change-password",
    required: true,
    viewPassword: true,
    showPassword: true,
    type: formTypes.password,
  }
  return (
    <div>
      <div className="modal-add-murdered">Cambiar contraseña</div>
      <div>
        <Form
          onSubmit={props.onSubmit}
          onChange={props.onChange}
          objectCreator={[ 
            {
              type: formTypes.div,
              classContainer: "line line-100"
            },
            {
              type: formTypes.div,
              classContainer: "line line-40"
            },
            {
              type: formTypes.buttonclick,
              classContainer: "button-primary line line-20 text-center auto-width",
              label: "Autogenerar",
              placeholder: "-",
              onClick: props.autoGen
            },
            {
              type: formTypes.div,
              classContainer: "line line-100"
            },
            {
              type: formTypes.div,
              classContainer: "line line-20"
            },
            {
              ...defaultProperties,
              label: "Contraseña nueva",
              placeholder: "Dígite su nueva contraseña",
              variable: "newPassword",
            },
            {
              type: formTypes.div,
              classContainer: "line line-100"
            },  
            {
              type: formTypes.div,
              classContainer: "line line-20"
            },
            {
              ...defaultProperties,
              label: "Confirmar contraseña",
              placeholder: "Confirme su nueva contraseña",
              variable: "confirmNewPassword",
              equalTo: "newPassword",
            },
            {
              type: formTypes.div,
              classContainer: "line line-100"
            },
            {
              type: formTypes.div,
              classContainer: "line line-30"
            },
            {
              type: formTypes.submit,
              classContainer: "button-primary line line-20 text-center",
              label: "Aceptar",
              placeholder: "-",
            },
            {
              type: formTypes.buttonclick,
              classContainer: "button-primary line line-20 text-center",
              label: "Cancelar",
              placeholder: "-",
              onClick: props.onCancel
            },
          ]}
          values={props.values}
        />
      </div>
    </div>
  )
}

export default ChangePassAdmin